// ** Reducers Imports
import { combineReducers } from 'redux';
import navbar from './navbar'
import layout from './layout'
import navbarContent from './reducers/navbarContent';
import document from "./reducers/document";
import organisationReducer from './reducers/organisation';
import uploadHistory from './reducers/uploadHistory';

const rootReducer = combineReducers({
  navbar,
  layout,
  navbarContent,
  document,
  organisationReducer,
  uploadHistory,
});

export default rootReducer
